import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { Card as AntdCard } from 'antd'

export const TitleWrapper = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
`

export const ContentWrapper = styled.span`
  font-size: 14px;
  margin-left: 10px;
  color: ${themeColor('blackPrimary')};
`

export const StyledAntdCard = styled(AntdCard)`
  margin-top: 10px;
  padding-bottom: 20px;
  &&.ant-card.ant-card-bordered {
    background-color: rgba(7, 7, 15, 0.1);
    border: 1px solid ${themeColor('greyPrimary')};
  }
`

// PBI 147363 - Documentation 4: Padding per Figma specs (25px uniform on all sides)
export const SwitchListContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 25px 0px 25px 25px;
  overflow-y: auto;
  background: #fbfbfb;
  scrollbar-width: thin;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }

  .ant-col {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
`
